import { rem } from 'polished'

import { css, styled } from '../../theme'
import { colors } from '../../theme/colors'
import { font } from '../../theme/font'
import { media } from '../../theme/media'

export const Wrapper = styled.label`
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  width: 100%;
  height: ${rem(60)};

  color: transparent;

  &:focus {
    ${media.onlyMobile` ${font.xs()}`};
    ${media.tablet` ${font.s()}`};
  }
`

export const InputField = styled.input.attrs({})<{ hasError?: boolean }>`
  width: 100%;
  height: ${rem(30)};

  ${media.onlyMobile` ${font.s()}`};
  ${media.tablet` ${font.m()}`};

  background-color: transparent;
  border: none;
  border-bottom: 1px solid
    ${p => (p.hasError ? colors.ternary : colors.primary)};
  &:focus {
    text-overflow: ellipsis;
  }
`

export const Label = styled.span.attrs({})<{
  required: boolean
  elevated: boolean
}>`
  display: block;
  position: absolute;
  top: ${rem(25)};
  left: 0;
  width: 100%;

  ${media.onlyMobile` ${font.s()}`};
  ${media.tablet` ${font.s()}`};

  color: ${colors.grayDark};
  z-index: 2;
  transition: top 0.2s ease, font-size 0.2s ease, color 0.2s ease;
  ${p =>
    p.elevated &&
    css`
      top: 0;
      ${media.onlyMobile` ${font.xs()}`};
      ${media.tablet` ${font.xs()}`};
    `}

  ${p =>
    p.required &&
    css`
      &:after {
        content: '*';
      }
    `}
`

export const ErrorMessage = styled.div`
  color: ${colors.ternaryDark};
  font-size: ${font.s()};
`
